export default {
  state: {
    branchChartData: null,
    saleGroupChartData: null,
    agentChartData: null,
    distributionChannelChartData: null,
    pointChartData: null,
    productCategoryChartDate: null,
    productBrandChartDate: null,
    productSkuChartDate: null
  },
  mutations: {
    setBranchChartData (state, payload) {
      state.branchChartData = payload
    },
    setSaleGroupChartData (state, payload) {
      state.saleGroupChartData = payload
    },
    setAgentChartData (state, payload) {
      state.agentChartData = payload
    },
    setDistributionChannelChartData (state, payload) {
      state.distributionChannelChartData = payload
    },
    setPointChartData (state, payload) {
      state.pointChartData = payload
    },
    setProductCategoryChartData (state, payload) {
      state.productCategoryChartData = payload
    },
    setProductBrandChartData (state, payload) {
      state.productBrandChartData = payload
    },
    setProductSkuChartData (state, payload) {
      state.productSkuChartData = payload
    }
  },
  actions: {
    async branchChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/branch/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setBranchChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async saleGroupChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/sale_group/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSaleGroupChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async agentChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/agent/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setAgentChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async distributionChannelChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/distribution_channel/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setDistributionChannelChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async pointChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/point/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setPointChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async productCategoryChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/product/category/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setProductCategoryChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async productBrandChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/product/brand/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setProductBrandChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async productSkuChartData ({commit, dispatch}, post) {
      post = {data: post}
      post.url = '/admin/stat/product/sku/list?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setProductSkuChartData', data.chart_series_list)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    branchChartData (state) {
      return state.branchChartData
    },
    saleGroupChartData (state) {
      return state.saleGroupChartData
    },
    agentChartData (state) {
      return state.agentChartData
    },
    distributionChannelChartData (state) {
      return state.distributionChannelChartData
    },
    pointChartData (state) {
      return state.pointChartData
    },
    productCategoryChartData (state) {
      return state.productCategoryChartData
    },
    productBrandChartData (state) {
      return state.productBrandChartData
    },
    productSkuChartData (state) {
      return state.productSkuChartData
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/statistics.js